import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BookingService from '../../api/services/BookingManually';
import MainPagetitle from '../../layouts/MainPagetitle';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import ReactFlagsSelect from "react-flags-select";
import Select from 'react-select';
const AddBooking = () => {
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [birthdate, setBirthdate] = useState('');
  const [birtherror, setBirtherrror] = useState('');
  const [selectedConutry, setSelectedCountry] = useState("");
  const [isLoading, setisloading] = useState(false);
  const [user, setUser] = useState([]);
  const [checked, setChecked] = useState(true);
  useEffect(() => {
    getUsers();
  }, []);
  // ----------- get Camper  ------------ //
  const handleBirthdate = (e) => {

    let input = e.target.value;

    // Remove any non-digit characters
    input = input.replace(/\D/g, '');

    // Format the date as dd/mm/yyyy
    if (input.length <= 2) {
      setBirthdate(input);
    } else if (input.length <= 4) {
      setBirthdate(`${input.slice(0, 2)}/${input.slice(2)}`);
    } else {
      setBirthdate(`${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`);

    }

    const currentYear = new Date().getFullYear();
    const year = e.target.value.split("/")[2];
    const month = e.target.value.split("/")[1];
    const day = e.target.value.split("/")[0];
    const age = currentYear - year;
    if (month >= 13 || age < 21 || day >= 32) {
      setBirtherrror("You have to be at least 21 years old");
    }
    else {
      setBirtherrror("");
    }

  }
  const getUsers = async () => {
    let responseData =  await BookingService.getusers().json()
    setUser(responseData.data);
  }
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    if (birtherror != "" || birtherror != "") {
      setBirtherrror("")
      setError("You have to be at least 21 years old");
    }
    else {
      try {
        if(checked){
          var registerdata = {
            "name": event.target.firstname.value,
            "email": event.target.email.value,
            "password": "password",
            "phone": event.target.phone.value,
            "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
          }
          let registrationData = await BookingService.register(registerdata).json();
          if (registrationData.status === true) {
            var userData = {
              "name": event.target.firstname.value,
              "email": event.target.email.value,
              "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
              "phone": event.target.phone.value,
              "address": event.target.address.value,
              "street": event.target.street.value,
              "zip": event.target.zip.value,
              "city": event.target.city.value,
              "country": selectedConutry ? selectedConutry : '',
              "company": event.target.value ? event.target.company.value : '',
              "vat_id": event.target.value ? event.target.vat_id.value : '',
              "status": 0,
              "user_id": registrationData.user_id
            }
            let responseData = await BookingService.store(userData).json()
            if (responseData.status === true) {
              navigate("/admin/booking");
            }
          }
        }else{
          var userData = {
            "name": event.target.firstname.value,
            "email": event.target.email.value,
            "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
            "phone": event.target.phone.value,
            "address": event.target.address.value,
            "street": event.target.street.value,
            "zip": event.target.zip.value,
            "city": event.target.city.value,
            "country": selectedConutry ? selectedConutry : '',
            "company": event.target.value ? event.target.company.value : '',
            "vat_id": event.target.value ? event.target.vat_id.value : '',
            "status": 0,
            "user_id": event.target.users.value
          }
          let responseData = await BookingService.store(userData).json()
          if (responseData.status === true) {
            navigate("/admin/booking");
          }
        }
        /*var userData = {
          "name": event.target.name.value,
          "email": event.target.email.value,
          "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
          "phone": event.target.phone.value,
          "address": event.target.address.value,
          "street": event.target.street.value,
          "zip": event.target.zip.value,
          "city": event.target.city.value,
          "status": 1,
          "country": selectedConutry ? selectedConutry : '',
          "company": event.target.value ? event.target.company.value : '',
          "vat_id": event.target.value ? event.target.vat_id.value : '',
        }

        let responseData = await BookingService.store(userData).json()
        if (responseData.status === true) {
          navigate("/admin/booking");
        }*/
      } catch (error) {
        if (error.name === 'HTTPError') {
          const errorJson = await error.response.json();
          setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
        }
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Add Booking" pageTitle={'Add Booking'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Booking</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmitForm}>
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <input type="checkbox" checked={checked} onChange={handleChange}/> Guest Checkout
                    </div>
                    {
                      !checked? <div className="col-xl-12 mb-3">
                      <label  className="form-label" >User</label>
                      <Select
                        name='users'
                        options={user}
                        getOptionValue={(option) => option.id}
                        getOptionLabel={(option) =>
                          option.name+" ("+option.email +")"
                        }
                        />
                    </div>:''
                  }
                   
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >First & last name<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='firstname' id="val-username" placeholder="" />
                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" > Email <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='email' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Phone<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='phone' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Date of birth<span className="text-danger">*</span></label>
                      <input
                        className="form-control"
                        type="text"
                        value={birthdate}
                        placeholder="DD/MM/YYYY" name="dob" onChange={handleBirthdate}
                      />
                      <div className="px-4 py-1 h-6 font-light"></div> {birtherror ? <p style={{ color: "red" }} >{birtherror}</p> : ''}
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Street <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='street' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Address addition </label>
                      <input type="text" className="form-control" name='address' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Zip  <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='zip' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >City  <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='city' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Country <span className="text-danger">*</span></label>
                      <ReactFlagsSelect
                        selected={selectedConutry}
                        onSelect={(code) => setSelectedCountry(code)}
                        className="flag-container flex items-center justify-around  py-2 h-11 bg-white focus-within:border focus-within:border-primary rounded-t-xl hover:shadow rounded-b-xl"
                        selectButtonClassName="w7 h-7"
                        id="icon-location"
                        searchable

                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Company </label>
                      <input type="text" className="form-control" name='company' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >VAT-ID </label>
                      <input type="text" className="form-control" name='vat_id' id="val-username" placeholder="" />
                    </div>
                  </div>
                  <h5 style={{ color: 'red' }}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>

      </div>
      {isLoading && <LogoAnimationLoader />}
    </>
  );
};
export default AddBooking;